import { API_ENDPOINTS, withParams } from '../config/apis';
import { apiRequest } from '../api/client';

/** 건타임 그룹 — 백엔드 GroupResponse (목록 nested) */
export type Group = {
  groupId: number;
  groupName: string;
  /** 'YYYY-MM-DDTHH:mm:ss' (LocalDateTime). 대회날짜 + 출발 시각 */
  gunTime: string;
};

/** 종목 — 백엔드 CategoryResponse (groups 중첩 포함) */
export type Category = {
  id: number;
  eventId: number;
  categoryName: string;
  groups: Group[];
};

export type GroupBody = {
  groupName: string;
  /** LocalDateTime 문자열 */
  gunTime: string;
};

export const categoryService = {
  list: (eventId: number) =>
    apiRequest<{ categories: Category[] }>(withParams(API_ENDPOINTS.categoryList, { eventId })).then(
      (res) => res.categories
    ),

  createCategory: (eventId: number, categoryName: string) =>
    apiRequest<{ id: number; eventId: number; categoryName: string }>(
      withParams(API_ENDPOINTS.categoryCreate, { eventId }),
      { body: { categoryName } }
    ),

  updateCategory: (eventId: number, categoryId: number, categoryName: string) =>
    apiRequest<void>(
      withParams(API_ENDPOINTS.categoryUpdate, { eventId, categoryId }),
      { body: { categoryName } }
    ),

  deleteCategory: (eventId: number, categoryId: number) =>
    apiRequest<void>(withParams(API_ENDPOINTS.categoryDelete, { eventId, categoryId })),

  createGroup: (eventId: number, categoryId: number, body: GroupBody) =>
    apiRequest<{ id: number; categoryId: number; groupName: string; gunTime: string }>(
      withParams(API_ENDPOINTS.groupCreate, { eventId, categoryId }),
      { body }
    ),

  updateGroup: (eventId: number, categoryId: number, groupId: number, body: GroupBody) =>
    apiRequest<void>(
      withParams(API_ENDPOINTS.groupUpdate, { eventId, categoryId, groupId }),
      { body }
    ),

  deleteGroup: (eventId: number, categoryId: number, groupId: number) =>
    apiRequest<void>(withParams(API_ENDPOINTS.groupDelete, { eventId, categoryId, groupId })),
};
